import axios from 'axios';

const CancelToken = axios.CancelToken;
const CENTER_RESOLUTION = 5; //rounded to ~1m

export class StoreLocatorService {
  getStores(center, origin, filter) {
    if (this.call) {
      this.call.cancel();
    }
    this.call = CancelToken.source();
    return axios.get('/api/v2/stores.json', {
      params: {
        center_lat: center.lat.toFixed(CENTER_RESOLUTION),
        center_lng: center.lng.toFixed(CENTER_RESOLUTION),
        origin_lat: origin.lat.toFixed(CENTER_RESOLUTION),
        origin_lng: origin.lng.toFixed(CENTER_RESOLUTION),
        search_result_type: JSON.stringify(filter),
      },
      responseType: 'json',
      cancelToken: this.call.token
    }).then(response => response.data);
  }

  getCoordinatesByPostcode(postcode) {
    return axios.get('/api/v2/location.json', {
      params: {
        postcode: postcode
      },
      responseType: 'json'
    }).then(response => response.data);
  }

  getRetailers(abortController) {
    const options = {responseType: 'json'};
    if (abortController) {
      options["signal"] = abortController.signal;
    }
    return axios.get('/api/v2/retailers.json', options).then(response => response.data);
  }
}
